<template lang="html">
  <div class="loader__overlay">
    <div class="lds-hourglass"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="sass" scoped>
  .loader__overlay
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-color: rgba(255,255,255,0.5)
    z-index: 20

  .lds-hourglass
    position: absolute
    top: 50%
    left: 50%
    width: 80px
    height: 80px
    margin-top: -40px
    margin-left: -40px

  .lds-hourglass:after
    content: " "
    display: block
    border-radius: 50%
    width: 0
    height: 0
    margin: 8px
    box-sizing: border-box
    border: 32px solid #999
    border-color: #999 transparent #999 transparent
    animation: lds-hourglass 1.2s infinite

  @keyframes lds-hourglass
    0%
      transform: rotate(0)
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19)
    50%
      transform: rotate(900deg)
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)
    100%
      transform: rotate(1800deg)
</style>
